module.exports = __webpack_public_path__ + "img/mppd.8f59b7aa.png";